/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const target = event.target;
  console.log(event, 'EVENT');
  if (event.target.dataset.toggleTarget) {
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    tabToggle(event);
  }
  if (event.target.dataset.modalTarget) {
    modalPop(event);
  }
  if (event.target.hasAttribute('data-toggle-reset')) {
    // console.log('reset toggles');
    const toggles = document.querySelectorAll('[data-toggle-target]');
    const targets = document.querySelectorAll('[data-toggle-content]');
    toggles.forEach((toggle) => {
      toggle.classList.remove('active');
    });
    targets.forEach((toggle) => {
      toggle.classList.remove('active');

      setTimeout(function () {
        toggle.style.height = '0px';
      }, 500);
    });
  }

  if (event.target.hasAttribute('data-toggle-close')) {

    const target = event.target.dataset.toggleClose;
    console.log('close toggle', target);
    document
    .querySelector(`[data-toggle-target="${target}"]`)
    .classList.remove('active');
    document
    .querySelector(`[data-toggle-content="${target}"]`)
    .classList.remove('active'); 
  }




  if (event.target.hasAttribute('data-close')) {
    console.log('eventclose', event);
    const target = event.target.dataset.close;
    document
    .querySelector(`[data-toggle-target="${target}"]`)
    .classList.remove('active');
    document
    .querySelector(`[data-toggle-content="${target}"]`)
    .classList.remove('active');
     event.target.removeAttribute('data-close');
  } 
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      const target = item.dataset.closeOutside;
      document
      .querySelector(`[data-toggle-target="${target}"]`)
      .classList.remove('active');
      document
      .querySelector(`[data-toggle-content="${target}"]`)
      .classList.remove('active');

       document.querySelector('[data-close]').removeAttribute('data-close');
    });

    //console.log('Escape key pressed');
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();
  console.log('slide down toggle');
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');
  const target = event.target.dataset.toggleTarget;

  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );
  console.log(toggleContainer.length, 'TOGGLE CONTAINER');

  const body = document.querySelector('body');

  if (event.target.hasAttribute('data-reset')) {
    toggles.forEach((toggle) => {
      if (toggle.dataset.toggleTarget === target && toggle.classList.contains('active')) {
        toggle.classList.remove('active');
      } else {
        toggle.classList.add('active');
      }
      if (toggle.dataset.toggleTarget !== target) {
        toggle.classList.remove('active');
      }
    });
    targets.forEach((toggle) => {
      if (toggle.dataset.toggleContent !== target) {
        toggle.classList.remove('active');
      }
    });
  }

  toggleContainer.forEach((group) => {
    if (!group.classList.contains('active')) {
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.add('active');
        }
      });


      if (event.target.hasAttribute('data-close-outside')) {
        const closetarget = event.target.dataset.closeOutside;
        document.querySelector('body').setAttribute('data-close', closetarget);
      }

      group.classList.add('active');
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      setTimeout(function () {
        group.style.height = height;
      }, 0);

      group.removeEventListener('transitionend', handleTransitionEnd);
      group.addEventListener('transitionend', handleTransitionEnd, { once: true });
    } else {



      toggles.forEach((toggle) => {
        body.removeAttribute('data-close');
        console.log('close toggle', body);
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.remove('active');
        }
      });

      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = height;

      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        group.style.height = '0px';
      }, 0);

      group.removeEventListener('transitionend', handleTransitionEnd);
      group.addEventListener('transitionend', handleTransitionEnd, { once: true });
    }
  });

  function handleTransitionEnd() {
    this.style.height = 'auto';
  }
}



/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  const isMobileToggle = event.target.hasAttribute('data-mobile-toggle') && window.innerWidth < 749;

  if (isMobileToggle) { 
    if (event.target.classList.contains('active')) {
      // Close the tab if it's already active
      event.target.classList.remove('active');
      document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
        .forEach((content) => content.classList.remove('active')); 
    } else {
      // Open the tab
      tabGroups.forEach((group) => group.classList.remove('active'));
      event.target.classList.add('active');
      document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
        .forEach((content) => content.classList.add('active')); 
    }
  } else {
    // For non-mobile toggles
    tabGroups.forEach((group) => {
      console.log(group, ' GROUP');
      group.classList.remove('active');
  
    });
    event.target.classList.add('active');
    document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
      .forEach((content) => {
        content.classList.add('active')

        const sliders = content.querySelectorAll('.bd-slider'); 
        sliders.forEach((slider) => {
          const sliderData = Flickity.data(slider);
          console.log(sliderData, 'Slider FLickity');
          sliderData.resize();
        }); 
       });

    

  }
}

// MODAL TOGGLING
function modalPop(event) {
  console.log(event);
  event.preventDefault();
  const target = event.target.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  ); 
  console.log(modalContent, 'MODAL CONTENT'); 
  const closeBtns = modalContent.querySelectorAll('[data-close]'); 
  const modalSlider = modalContent.querySelector('.bd-slider');

  /* STUFF FOR PRODUCT QUOTE */
  const productContainer = event.target.closest('[data-product-item]');
  const quoteContainer = event.target.closest('[data-quote-item]'); 
  const quoteHeader = modalContent.querySelector('[data-default-title]') ?  modalContent.querySelector('[data-default-title]') : null;
  if (productContainer) { 
    console.log('product-container', productContainer);
    const productTitle = productContainer.dataset.productTitle; 
    const productImage = productContainer.querySelector('img');
    if (productImage) {
      modalContent.classList.add('with-image');
      console.log('with-image');
      localStorage.setItem('quoteProduct', productTitle);
      localStorage.setItem('quoteImageSrc', productImage.src);
      localStorage.setItem('quoteImageSrcset', productImage.srcset);
      quoteHeader ? quoteHeader.innerHTML = 'Request Quote for the': null;
      modalContent.querySelector('[data-product-image] img').src =
        productImage.src;
      modalContent.querySelector('[data-product-image] img').srcset =
        productImage.srcset;
      modalContent.querySelector('[data-product-title]').value = productTitle;
      modalContent.querySelector('[data-quote-display-title]').innerHTML =
        productTitle;
    } else {
      console.log('without-image'); 
      quoteHeader ? quoteHeader.innerHTML = 'Request a Quote/Contact Us': null;
    }
  } 
  if (quoteContainer) {
    console.log('non-product quote');
    modalContent.classList.add('general-quote');
    quoteHeader ? quoteHeader.innerHTML = 'Request a Quote/Contact Us': null;
  }

  /* END STUFF FOR PRODUCT QUOTE */
  repositionModal(modalContent);
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      closeModal(modalContent);
    });
  });

  window.onclick = function (event) {
    if (event.target == modalContent) {
      closeModal(modalContent);
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      closeModal(modalContent);
    }
  });
  if (modalSlider) {
    // Do stuff later if there is a slider in the modal
  }
}

function stopVideos() {
  document.querySelectorAll('iframe').forEach((v) => {
    v.src = v.src;
  });
  document.querySelectorAll('video').forEach((v) => {
    v.pause();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  document.querySelector('body').classList.remove('overflow-hidden');
  const cookie = modal.dataset.cookieModal ? modal.dataset.cookieModal : false;
  const days = modal.dataset.cookieExpires ? modal.dataset.cookieExpires : 5;
  if (cookie) {
    setCookie(cookie, 'seen', days);
  }
  stopVideos();
  restoreElement(modal);


    /* STUFF FOR PRODUCT QUOTE */
    localStorage.removeItem('quoteProduct');
    localStorage.removeItem('quoteImageSrc');
    localStorage.removeItem('quoteImageSrcset');
    modal.classList.remove('with-image');
    modal.querySelector('[data-product-image] img').src =
        '';
      modal.querySelector('[data-product-image] img').srcset =
       '';
      modal.querySelector('[data-product-title]').value = '';
      modal.querySelector('[data-quote-display-title]').innerHTML =
        '';
}

function repositionModal(elementToMove) {
  document.body.insertBefore(elementToMove, document.body.firstChild);
}

// To restore the element to its original position
function restoreElement(elementToMove) {
  const originalParent = elementToMove.parentNode;
  const originalNextSibling = elementToMove.nextSibling;
  if (originalNextSibling) {
    originalParent.insertBefore(elementToMove, originalNextSibling);
  } else {
    originalParent.appendChild(elementToMove);
  }
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
